import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogBoxCambioEstadoComponent } from './dialog/dialog-box-cambio-estado.component';
import { DialogBoxCopiarComponent } from './dialog/dialog-box-copiar.component';
import { DialogBoxPrintComponentDebidaDiligencia } from './dialog/dialog-print-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { DebidaDiligenciaService } from '../../services/debida-diligencia.service';
import { DebidaDiligencia } from 'app/main/models/debida-diligencia.model';
import { TablaDeEvaluacionService } from '../../services/tabla-de-evaluacion.service';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UsersService } from '../../services/users.service';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators,
} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DialogAnalisisBoxPrintComponentDebidaDiligencia } from './dialog/dialog-analisis-print-box.component';
import { DialogAnalisisBoxAnalyticsComponentDebidaDiligencia } from './dialog/dialog-analisis-analytics-box.component';
import { UtilsService } from '../../services/utils.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { Location } from '@angular/common';
import { FormularioDialogBoxComponent } from './sujeto-obligado/dialog/dialog-formulario-box.component';
import {DialogBoxDebidaDiligenciaComponent} from './dialog/dialog-box-debida-diligencia.component';
import {
    DialogBoxDebidaDiligenciaNuevoFormularioComponent
} from './formulario/dialog/dialog-box-debida-diligencia-nuevo-formulario.component';

@Component({
    selector: 'debida-diligencia-view',
    templateUrl: './debida-diligencia-view.component.html',
    styleUrls: ['./debida-diligencia-view.component.scss'],
})
export class DebidaDiligenciaViewComponent {
    displayedColumns: string[] = [
        'destinatario',
        'formulario',
        'estado',
        'fechaFin',
        'action',
    ];
    debidaDiligencia: DebidaDiligencia = null;
    selectedStatus: number;
    isEditable = false;
    isReseted = false;

    dataSource: any = [];
    destinatarios: any = [];

    is_eval_creador = false;
    is_responsable = false;

    editar_nombre = false;
    editar_estado = false;
    editar_tabla_de_evaluacion = false;
    editar_estructura = false;
    editar_marco_de_referencia = false;
    editar_responsable = false;
    editar_fecha_fin = false;
    nombre = '';

    estados: any[] = ['INICIADO', 'COMPLETADO', 'CERRADO'];

    marcosDeReferencia = [];
    estructuraJerarquicas = [];
    tablasDeEvaluacion = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];

    preiniciadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    iniciadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    completadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    aprobadoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });
    cerradoFormGroup: FormGroup = new FormGroup({
        firstName: new FormControl(),
    });

    isThisStepDone0 = false;
    isThisStepDone1 = false;
    isThisStepDone2 = false;
    isStepDone0 = '';
    isStepDone1 = '';
    isStepDone2 = '';

    selectedIndex = null;
    role = null;
    is_eval_owner = false;
    is_admin = false;

    fechaFin = null;
    editar_dueno = true;
    tipo = 'DEBIDA_DILIGENCIA';
    uuid: string;

    @ViewChild('stepper') private stepper: MatStepper;

    // @ViewChild("stepper") stepper: MatStepper;

    constructor(
        public dialog: MatDialog,
        private storage: TokenStorageService,
        private service: DebidaDiligenciaService,
        public serviceTablasDeEvaluacionService: TablaDeEvaluacionService,
        private _snackBar: MatSnackBar,
        public translate: TranslateService,
        public router: Router,
        public utils: UtilsService,
        private clipboard: Clipboard,
        private location: Location,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.uuid = params.get('uuid');

            this.service
                .getByUUID(this.uuid)
                .pipe()
                .subscribe((req) => {
                    this.debidaDiligencia = new DebidaDiligencia(req.body);

                    this.dataSource = this.debidaDiligencia.formularios;
                    this.destinatarios = this.debidaDiligencia.destinatarios;
                    this.loadEvalData();
                });
        });

        this.serviceTablasDeEvaluacionService
            .getAll(this.tipo, 0, 1000)
            .pipe()
            .subscribe((req) => {
                this.tablasDeEvaluacion = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

        // this.serviceMarcoDeReferenciaService.getAll(this.tipo,0,1000).pipe().subscribe(req => {
        //   this.marcosDeReferencia = req.body.map( tipo => {
        //     console.log(tipo);
        //     return {
        //       id: tipo.id,
        //       nombre: tipo.nombre
        //     };
        //   });
        // });
    }

    loadEvalData() {
        const user = this.storage.getUser();
        this.role = this.storage.getRole();
        this.setActiveStep();

        this.is_responsable = true;

        this.fechaFin = this.debidaDiligencia.fechaVencimiento;

        if (this.role != undefined && this.role.includes(2)) {
            this.is_admin = true;
        }
    }

    print(): void {
        this.service
            .downloadPDF2(this.debidaDiligencia.id)
            .subscribe((data) => {
                const blob = new Blob([data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'debidaDiligencia.pdf';
                a.click();
                window.URL.revokeObjectURL(url);
            });
        /*
        const dialogRef = this.dialog.open(
            DialogAnalisisBoxPrintComponentDebidaDiligencia,
            {
                panelClass: "my-full-screen-dialog",
                width: "95%",
                maxWidth: "95%",
                data: { action: "Print", obj: this.debidaDiligencia },
                autoFocus: false,
                disableClose: true,
            }
        );*/
    }

    shareLink(sentencias, nivel, esMatrizReverso): void {
        this.clipboard.copy(window.location.href + '/external');
        alert('Direccion de la debida diligencia copiada en el portapapeles');
    }

    goBack() {
        this.location.back();
    }

    navegateTo(id): void {
        this.router
            .navigateByUrl('debida-diligencia/' + this.uuid + '/form/' + id)
            .then((e) => {
                if (e) {
                    console.log('Navigation is successful!');
                } else {
                    console.log('Navigation has failed!');
                }
            });
    }

    openDialog(element): void {
        const obj = {
            ownerSelector: true,
            id: element.formulario.id,
            nombreCompleto: element.destinatario.nombreCompleto,
        };
        const dialogRef = this.dialog.open(FormularioDialogBoxComponent, {
            width: '100%',
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event == 'Delete') {
                this.service
                    .deleteFormulario(element.id)
                    .pipe()
                    .subscribe(
                        (req) => {
                            // limipar formulario de la lista
                            this.debidaDiligencia.formularios =
                                this.debidaDiligencia.formularios.filter(
                                    (item) => item.id !== element.id
                                );

                            this.dataSource = [
                                ...this.debidaDiligencia.formularios,
                            ];

                            this.openSnackBar(
                                'Se eliminó el formulario correctamente',
                                'Cerrar'
                            );
                        },
                        (err) => {
                            this.openSnackBar(
                                'No se pudo eliminar el formulario, ocurrió un error.',
                                'Cerrar'
                            );
                        }
                    );
            }
        });
    }

    openDialogNuevoFormulario(action, obj): void {
        obj.action = action;
        obj.destinatarios = this.destinatarios;
        const dialogRef = this.dialog.open(DialogBoxDebidaDiligenciaNuevoFormularioComponent, {
            width: '100%',
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === 'Add') {
                this.addDDRowData(result.data);
            } else if (result.event === 'Update') {
                this.updateDDRowData(result.data);
            } else if (result.event === 'Delete') {
                this.deleteDDRowData(result.data);
            }
        });
    }

    addDDRowData(rowObj: { formulario: any; destinatario: any; }): void {
        this.service
            .addFormulario(this.debidaDiligencia.UUID, {formulario: rowObj.formulario, destinatario: rowObj.destinatario})
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.formularios.push(req.body);
                    this.dataSource = [...this.debidaDiligencia.formularios];
                    this.openSnackBar(
                        'Se ingresó el formulario correctamente',
                        'Cerrar'
                    );
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo ingresar el formulario, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    updateDDRowData(rowObj): void {
        this.service
            .editFormulario(rowObj.id, rowObj)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.formularios = this.debidaDiligencia.formularios.map(
                        (item) => {
                            if (item.id === rowObj.id) {
                                return rowObj;
                            }
                            return item;
                        }
                    );
                    this.dataSource = [...this.debidaDiligencia.formularios];
                    this.openSnackBar(
                        'Se actualizó el formulario correctamente',
                        'Cerrar'
                    );
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo actualizar el formulario, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    deleteDDRowData(rowObj): void {
        this.service
            .deleteFormulario(rowObj.id)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.formularios = this.debidaDiligencia.formularios.filter(
                        (item) => item.id !== rowObj.id
                    );
                    this.dataSource = [...this.debidaDiligencia.formularios];
                    this.openSnackBar(
                        'Se eliminó el formulario correctamente',
                        'Cerrar'
                    );
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo eliminar el formulario, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    selectEstado(): void {
        this.editar_estado = false;
    }

    selectRespuesta(sentencia, respuesta): void {
        this.service
            .addRespuesta(
                this.debidaDiligencia.UUID,
                sentencia.id,
                respuesta.value
            )
            .pipe()
            .subscribe(
                (req) => {},
                (err) => {
                    this.openSnackBar(
                        'No se pudo registrar la respuesta, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    updateName(nombre): void {
        this.editar_nombre = false;

        this.service
            .editNombre(this.debidaDiligencia.id, nombre)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.nombre = nombre;
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo modificar el nombre, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    selectFormulario(escenario): void {
        this.editar_marco_de_referencia = false;

        this.service
            .editFormulario(this.debidaDiligencia.id, escenario.value)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.formulario = req.body;
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo modificar el escenario, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    selectResponsable(owner): void {
        this.editar_responsable = false;

        this.service
            .editResponsable(this.debidaDiligencia.id, owner.value)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.responsable = owner.value;
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo modificar el responsable, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    selectFechaFin(fecha): void {
        this.editar_fecha_fin = false;
        this.service
            .editFechaFin(this.debidaDiligencia.id, fecha.value)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.fechaVencimiento = fecha.value;
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo modificar la fecha de finalización, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    copiar(): void {
        const dialogRef = this.dialog.open(DialogBoxCopiarComponent, {
            width: '100%',
            data: { action: 'Copiar', obj: this.debidaDiligencia },
            disableClose: true,
        });
    }

    setIndex(event) {
        this.selectedIndex = event.selectedIndex;
    }

    changeStatus(): void {
        const ss = this.selectedStatus;
        let status = '';
        if (
            ss == 0 &&
            this.is_responsable &&
            this.debidaDiligencia.estado == 'INICIADO'
        ) {
            status = 'COMPLETADO';
        }
        if (
            ss == 1 &&
            this.is_responsable &&
            this.debidaDiligencia.estado == 'COMPLETADO'
        ) {
            status = 'CERRADO';
        }

        if (status != '') {
            const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
                width: '100%',
                data: { action: status },
                disableClose: true,
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result.event != 'Cancel') {
                    this.service
                        .editStatus(this.debidaDiligencia.id, status)
                        .pipe()
                        .subscribe(
                            (req) => {
                                this.debidaDiligencia.estado = status;
                                this.setActiveStep();
                                this.openSnackBar(
                                    'Se modificó el estado de la operación a ' +
                                        status,
                                    'Cerrar'
                                );
                            },
                            (err) => {
                                this.openSnackBar(
                                    'No se pudo modificar el estado, ocurrió un error.',
                                    'Cerrar'
                                );
                            }
                        );
                } else {
                    this.setActiveStep();
                }
            });
        }
    }

    setActiveStep(): void {
        this.isThisStepDone0 = false;
        this.isThisStepDone1 = false;
        this.isThisStepDone2 = false;
        this.isStepDone0 = '';
        this.isStepDone1 = '';
        this.isStepDone2 = '';

        if (this.debidaDiligencia.estado == 'INICIADO') {
            this.selectedStatus = 0;
        }
        if (this.debidaDiligencia.estado == 'COMPLETADO') {
            this.isThisStepDone0 = false;
            this.isStepDone0 = 'done';
            this.selectedStatus = 1;
        }
        if (this.debidaDiligencia.estado == 'CERRADO') {
            this.isThisStepDone0 = false;
            this.isStepDone0 = 'done';
            this.isThisStepDone1 = false;
            this.isStepDone1 = 'done';
            this.selectedStatus = 2;
        }

        if (this.stepper != null) {
            this.stepper.linear = false;
            this.stepper.selectedIndex = this.selectedStatus;
            setTimeout(() => {
                this.stepper.linear = true;
            });
        }
    }

    rechazar(): void {
        const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
            width: '100%',
            data: { action: 'Rechazar' },
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event != 'Cancel') {
                this.service
                    .editStatusRechazo(
                        this.debidaDiligencia.id,
                        'INICIADO',
                        result.motivo
                    )
                    .pipe()
                    .subscribe(
                        (req) => {
                            this.debidaDiligencia.estado = 'INICIADO';
                            this.stepper.previous();
                            this.setActiveStep();
                            this.openSnackBar(
                                'Se rechazo el análisis y se cambió el estado a ' +
                                    status,
                                'Cerrar'
                            );
                            window.location.reload();
                        },
                        (err) => {
                            this.openSnackBar(
                                'No se pudo modificar el estado, ocurrió un error.',
                                'Cerrar'
                            );
                        }
                    );
            }
        });
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    compareObjects(o1: any, o2: any): boolean {
        let equals = false;
        if (o1 != null && o2 != null) {
            equals = o1.nombre === o2.nombre && o1.id === o2.id;
        }
        return equals;
    }

    esEvaluadorGroup(usuario): boolean {
        let esEvaluador = false;

        usuario.tipos.forEach((element) => {
            if (element.id == 7) { esEvaluador = true; }
        });

        return esEvaluador;
    }

    orderStructure(nodos): void {
        for (let z = 0; nodos.length > z; z++) {
            nodos.sort(this.utils.sortAlphaNum);
            // nodos.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
            this.orderStructure(nodos[z].sentencias);
        }
    }

    selectDueno(owner): void {
        this.editar_dueno = false;

        this.service
            .editResponsable(this.debidaDiligencia.id, owner.value)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.responsable = owner.value;
                    this.editar_responsable = false;
                    // window.location.reload();
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo modificar el dueño, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }

    updateData(): void {
        this.debidaDiligencia.formulario.sentencias = [
            ...this.debidaDiligencia.formulario.sentencias,
        ];
    }

    guardarConclusion(): void {
        this.service
            .addConclusion(this.uuid, this.debidaDiligencia.conclusion)
            .pipe()
            .subscribe(
                (req) => {
                    this.debidaDiligencia.conclusion = req;
                    this.openSnackBar('Se guardó la conclusión', 'Cerrar');
                },
                (err) => {
                    this.openSnackBar(
                        'No se pudo guardar la conclusión, ocurrió un error.',
                        'Cerrar'
                    );
                }
            );
    }
}
